import { AlarmClock, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { IndexPath } from '@/Config/app/router/index.path';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/Domain/components/Shared/Empty/Empty';
import { InsightsPageTabsEnum } from '@/UI/Insights/insightsPageTabs';

export const EmptyAlertsState = () => {
  const { t } = useTranslation('insights_page', {
    keyPrefix: 'unified_ai_insights.empty_alerts',
  });
  const { scenario } = useParams<{ scenario: string }>();

  const examplesRaw = t('examples', { returnObjects: true });
  const examples: string[] = Array.isArray(examplesRaw) ? examplesRaw : [];

  return (
    <Empty data-testid="empty-alerts-state">
      <EmptyHeader className="w-full items-start text-left">
        <EmptyMedia variant="icon">
          <AlarmClock />
        </EmptyMedia>
        <EmptyTitle>{t('title')}</EmptyTitle>
        <EmptyDescription>{t('description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent className="items-start text-left">
        <div className="w-full text-left space-y-2">
          <p className="text-sm font-medium text-foreground">{t('examples_heading')}</p>
          <ul className="space-y-1.5 text-sm text-muted-foreground text-wrap">
            {examples.map((example) => (
              <li key={example} className="flex items-start gap-2">
                <span className="mt-1.5 size-1 shrink-0 rounded-full bg-muted-foreground" />
                <span>{example}</span>
              </li>
            ))}
          </ul>
        </div>
        <Button
          asChild
          variant="dark"
          size="md"
          className="w-full"
          data-testid="empty-alerts-cta-manage"
        >
          <Link
            to={`/i/${scenario}/${IndexPath.insights}?tab=${InsightsPageTabsEnum.ManageAlerts}`}
          >
            {t('cta')}
            <ArrowRight />
          </Link>
        </Button>
        <p className="w-full text-center text-xs text-foreground-subtle">{t('cta_subtext')}</p>
      </EmptyContent>
    </Empty>
  );
};
